module.exports = __webpack_public_path__ + "img/4_62.ad1ca800.png";